import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

interface FormData {
  name: string;
  phone: string;
}

export const useSendForm = () => {
  const [isPending, setPending] = useState(false);

  const sendForm = async (formData: FormData) => {
    setPending(true);
    try {
      await axios.post('https://integrat.leadactiv.ru/lead/site', {
        name: formData.name,
        phone: formData.phone,
      });

      toast.success('Заявка успешно отправлена!');
    } catch (error) {
      console.error('Error: ', error);
      toast.error('Произошла ошибка при отправке, попробуйте позже.');
    } finally {
      setPending(false);
    }
  };

  return { isPending, sendForm };
};
